<div class="left-menu-container text" outsideListener (clickOutside)="clickOutside($event)">
  <div class="left-menu-header">
    <div class="left-side">{{ 'Quick_menu' | translate }}</div>
    <div class="right-side" (click)="closeLeftMenu()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <div class="left-menu-sports-vertical">
    <div
      *ngFor="let leftItem of mainData; let i = index"
      class="left-menu-sports-vertical-item"
      (click)="getCountriesBySportsID(leftItem.SportId, i)"
      [routerLink]="['/allsports/' + leftItem.SportId]">
      <image-loader-utils [url]="this.sportsSvgList[leftItem.SportId]?.svgKey" extraClasses="left-menu-verticalsvg"></image-loader-utils>
      <div class="vertical-sport-name">{{ leftItem.SportName }}</div>
    </div>
  </div>

  <div class="left-menu-general-vertical">
    <ng-container *ngFor="let leftItem of this.leftMenuGeneralDataRebuild(this.leftMenuGeneralData)">
      <div *ngIf="leftItem.standingType; else elseBlock" class="left-menu-general-vertical-item" (click)="openStats(leftItem.standingType)">
        <div class="general-vertical-sport-icon">
          <image-loader-utils [url]="leftItem.svgPath" extraClasses="left-menu-verticalsvg general-vertical-sport-svg"></image-loader-utils>
        </div>
        <div class="general-vertical-sport-name">
          {{ leftItem.title | translate }}
        </div>
      </div>
      <ng-template #elseBlock>
        <div class="left-menu-general-vertical-item" [routerLink]="[leftItem.routerLink]">
          <div class="general-vertical-sport-icon">
            <image-loader-utils [url]="leftItem.svgPath" extraClasses="left-menu-verticalsvg general-vertical-sport-svg"></image-loader-utils>
          </div>
          <div class="general-vertical-sport-name">
            {{ leftItem.title | translate }}
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="timer-container">
    {{ narvbarDateTime }}
  </div>
</div>
